@use "../../../sass/global/global" as *;

@property --gradient-color1 {
    syntax: "<color>";
    initial-value: rgba(255, 255, 255, 0.6);
    inherits: false;
}

@property --gradient-color2 {
    syntax: "<color>";
    initial-value: rgba(255, 255, 255, 0);
    inherits: false;
}

@property --gradient-color3 {
    syntax: "<color>";
    initial-value: rgba(255, 255, 255, 0.8);
    inherits: false;
}

ux-iws-nb-all-in-one-tile {
    --background-color: #{$color-white};
    --heading-color: #{$color-black-1};
    --text-color: #{$color-black-1};
}

ux-iws-nb-all-in-one-tile {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    @include font(light);
    background-color: var(--background-color);
    color: var(--text-color);
    width: 100%;
    min-height: 240px;
    cursor: pointer;

    * {
        box-sizing: border-box;
    }

    h2,
    h3,
    h4 {
        @include font(bold);
        font-size: 20px;
        line-height: 1.2;
        margin: 0;
        color: inherit;
    }

    p {
        @include font(light);
        font-size: 16px;
        line-height: 1.2;
        margin: 0;
        color: inherit;
    }

    p:not(:last-of-type) {
        margin-bottom: 1em;
    }
}

.ux-iws-nb-all-in-one-tile {
    &__image {
        position: absolute;
        inset: 0;
        width: auto;
        height: auto;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__gradient {
        --gradient-color1: rgba(255, 255, 255, 0.6);
        --gradient-color2: rgba(255, 255, 255, 0);
        --gradient-color3: rgba(255, 255, 255, 0.8);

        position: absolute;
        inset: 0;
        width: auto;
        height: auto;
        transition:
            --gradient-color1 0.3s ease-out,
            --gradient-color2 0.3s ease-out,
            --gradient-color3 0.3s ease-out;
        background:
            linear-gradient(
                0deg,
                var(--gradient-color1),
                var(--gradient-color1)
            ),
            linear-gradient(
                180deg,
                var(--gradient-color2) 0%,
                var(--gradient-color3) 100%
            ),
            linear-gradient(
                270deg,
                var(--gradient-color2) 37.37%,
                var(--gradient-color3) 100%
            );
    }

    &__content {
        position: relative;
        padding: 30px;
        margin: 0;
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;

        @media (min-width: 1024px) and (max-width: 1439px) {
            width: 50%;
        }
    }

    &__title {
        @include font(bold);
        font-size: 20px;
        line-height: 1.2;
        margin: 0 0 1rem;
        max-width: 400px;
    }

    &__text {
        @include font(light);
        font-size: 1rem;
        line-height: 1.2;
        flex: 1 0 auto;
        max-width: 400px;
    }

    &__cta {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-end;
        justify-content: flex-end;
        width: 100%;
        border-top: 1px solid var(--text-color);
        padding-top: 15px;
        margin-top: 30px;
    }

    &__cta-button {
        appearance: none;
        display: flex;
        flex-flow: row nowrap;
        gap: 1rem;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: 0 none;
        padding: 12px 0;
        cursor: pointer;
        margin: 0 0 -12px;
        background: transparent;
        color: inherit;
        @include font(bold);
    }

    &__cta-button:focus-visible {
        outline: 2px solid var(--ux-button-focus-border-color);
        outline-offset: 2px;
    }

    .ux-label {
        margin: 0;
        padding: 0;
        line-height: 1.2;
        text-align: left;
    }

    ux-icon {
        transform-origin: center;
        transition: transform 0.3s ease-out;
    }
}

ux-iws-nb-all-in-one-tile:hover {
    --background-color: #{$color-blue-headline};
    --heading-color: #{$color-white};
    --text-color: #{$color-white};
    --ux-button-focus-border-color: #{$color-white};

    .ux-iws-nb-all-in-one-tile__gradient {
        --gradient-color1: rgba(0, 80, 116, 0);
        --gradient-color2: rgba(0, 80, 116, 0);
        --gradient-color3: rgba(0, 80, 116, 1);
    }

    ux-icon {
        transform: rotate(90deg);
    }
}

ux-iws-nb-all-in-one-tile[active]:not([active="false"]) {
    --background-color: #{$color-blue-headline};
    --heading-color: #{$color-white};
    --text-color: #{$color-white};
    --ux-button-focus-border-color: #{$color-white};

    .ux-iws-nb-all-in-one-tile__gradient {
        --gradient-color1: rgba(0, 80, 116, 0.6);
        --gradient-color2: rgba(0, 80, 116, 0);
        --gradient-color3: rgba(0, 80, 116, 1);
    }

    ux-icon {
        transform: rotate(135deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    ux-iws-nb-all-in-one-tile ux-icon {
        transition: none;
    }
}
